import * as Yup from "yup";
import { IFormField, IFormFieldValue } from "../../helpers/interfaces/generic";

const msg_required = "Campo obbligatorio."
const msg_min3 = "La stringa deve contenere un minimo di 3 caratteri."
const msg_max30 = "La stringa può contenere un massimo di 30 caratteri."
const msg_min_order = "Il valore minimo consentito è 1."
const msg_max_order = "Il valore massimo consentito è 30."
const msg_integer_order = "Inserisci un numero intero valido."

const orderNumberValidation = Yup
  .number()
  .transform((value, originalValue) => originalValue === '' ? null : value)
  .nullable()
  .integer(msg_integer_order)
  .min(1, msg_min_order)
  .max(30, msg_max_order)
  .required(msg_required);

export function addPracticeCategoryFormFields(categorie: IFormFieldValue[]): Array<IFormField> {
  return [
    {
      'label': 'Nome',
      'name': 'name',
      'type': 'text',
      'class': 'form-control',
      'validation': Yup
        .string()
        .max(30, msg_max30)
        .matches(
          /(?=\S)[^\\]/,
          "Il nome della categoria è obbligatorio e non puo' contenere solo spazi."
        )
        .required(msg_required)
    },
    {
      'label': 'Categoria padre',
      'name': 'parent_id',
      'type': 'select',
      'values': categorie,
      'class': 'form-select'
    },
    {
      'label': 'Codice',
      'name': 'code',
      'type': 'text',
      'class': 'form-control',
      'validation': Yup.string().min(3, msg_min3).max(30, msg_max30).required(msg_required)
    },
    {
      'label': 'Ordine',
      'name': 'orderNumber',
      'type': 'number',
      'class': 'form-control',
      'min': 1,
      'max': 30,
      'value': 2,
      'validation': orderNumberValidation
    }
  ];
}

export function editPracticeCategoryFormFields(categorie: IFormFieldValue[]): Array<IFormField> {
  return [
    {
      'label': 'Nome',
      'name': 'name',
      'type': 'text',
      'class': 'form-control',
      'validation': Yup
        .string()
        .max(30, msg_max30)
        .matches(
          /(?=\S)[^\\]/,
          "Il nome della categoria è obbligatorio e non puo' contenere solo spazi."
        )
        .required(msg_required)
    },
    {
      'label': 'Categoria padre',
      'name': 'parent',
      'type': 'select',
      'values': categorie,
      'class': 'form-select',
      'disabled': true
    },
    {
      'label': 'Codice',
      'name': 'code',
      'type': 'text',
      'class': 'form-control',
      'validation': Yup.string().min(3, msg_min3).max(30, msg_max30).required(msg_required)
    },
    {
      'label': 'Ordine',
      'name': 'orderNumber',
      'type': 'number',
      'class': 'form-control',
      'min': 1,
      'max': 30,
      'value': 2,
      'validation': orderNumberValidation
    }
  ];
}
